const Data = {
  user_id: "",
  omniAuthDetails: { 'account_from_omni_auth': false },
  email: "",
  name: "",
  contact_phone: "",

  job_filter: {
    category: "",
    category_id: null,
    suburb: "",
    suburb_id: null
  }
}

export default Data
